module.exports = __webpack_public_path__ + "static/media/roller10.7756bcaa.svg";